import { BillToModelCollection, GetBillingParams, getBillToDetails } from "@NA/Services/ADIBillToService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<GetBillingParams, BillToModelCollection>;

export const DispatchloadBillTo: HandlerType = (props: any) => {
    if (props.parameter.getBillingChild) {
        props.dispatch({
            type: "Custom/loadChildBillTo",
            result: props.parameter,
        });
    } else {
        props.dispatch({
            type: "Custom/loadParentBillTo",
            result: props.parameter,
        });
    }
};

export const LoadBillToOptions: HandlerType = async (props: any) => {
    props.apiResult = await getBillToDetails(props.parameter);
};

export const DispatchCompleteLoadBillToOptions: HandlerType = props => {
    if (props.parameter.getBillingChild) {
        props.dispatch({
            type: "Custom/DispatchCompleteLoadChildBillTo",
            billToChildState: props.apiResult,
        });
    } else {
        props.dispatch({
            type: "Custom/DispatchCompleteLoadParentBillTo",
            billToParentState: props.apiResult,
        });
    }
};

export const chain = [DispatchloadBillTo, LoadBillToOptions, DispatchCompleteLoadBillToOptions];

const loadBillToCustom = createHandlerChainRunner(chain, "loadBillTo");
export default loadBillToCustom;
